<script setup>
import {
  ref,
  toRef,
  reactive,
  onMounted,
  onUnmounted,
  inject,
  getCurrentInstance,
  computed,
  watch
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useInfoStore } from '@/stores/counter.js'
import { shouldUseMobileLayout } from '@/util/mobileMode'

const isMobile = ref(shouldUseMobileLayout())
const updateMobileMode = () => {
  isMobile.value = shouldUseMobileLayout()
}

onMounted(() => {
  updateMobileMode()
  window.addEventListener('resize', updateMobileMode)
  window.addEventListener('hashchange', updateMobileMode)
  window.addEventListener('popstate', updateMobileMode)
})
onUnmounted(() => {
  window.removeEventListener('resize', updateMobileMode)
  window.removeEventListener('hashchange', updateMobileMode)
  window.removeEventListener('popstate', updateMobileMode)
})

let { proxy } = getCurrentInstance()
const goLogin = () => {
  proxy.$mitt.emit('goLogin', '去登陆')
}
const goPay = () => {
  proxy.$mitt.emit('goPay', '去支付')
}
const route = useRoute()
const router = useRouter()
const routeActive = ref(0)
const logoutParams = reactive({
  duid: '',
  time: '',
  sign: ''
})
const userStore = useInfoStore()
const useInfo = computed(() => {
  return userStore.userInfo
})

const goTo = (tab, path) => {
  routeActive.value = tab
  router.push(path)
}
watch(
  () => router.currentRoute.value.path,
  (newValue, oldValue) => {
    updateMobileMode()
    switch (newValue) {
      case '/':
        routeActive.value = 0
        break
      case '/channel':
        routeActive.value = 1
        break
      case '/points_shop_page':
        routeActive.value = 2
        break
      case '/pay':
        routeActive.value = 3
        break
      case '/info':
        routeActive.value = 4
        break

      default:
        break
    }
  },
  { immediate: true, deep: true }
)
</script>

<template>
  <header v-if="isMobile" class="mobile-nav-wrapper">
    <img src="@/assets/img/mobile_home/底部栏的BG.png" class="mobile-nav-bg" />
    <section class="header">
      <nav class="mobile-nav-items">
        <aside class="nav-item" @click="goTo(0, '/')">
          <img
            v-if="routeActive == 0"
            src="@/assets/img/mobile_home/Home -x.png"
            alt=""
            class="tab-icon-a"
          />
          <img v-else src="@/assets/img/mobile_home/Home.png" alt="" class="tab-icon-n" />
        </aside>
        <aside class="nav-item" @click="goTo(1, '/channel')">
          <img
            v-if="routeActive == 1"
            src="@/assets/img/mobile_home/INFO-x.png"
            alt=""
            class="tab-icon-a"
          />
          <img v-else src="@/assets/img/mobile_home/INFO_.png" alt="" class="tab-icon-n" />
        </aside>
        <aside class="nav-item" @click="goTo(2, '/points_shop_page')">
          <img
            v-if="routeActive == 2"
            src="@/assets/img/mobile_home/Points Store-x.png"
            alt=""
            class="tab-icon-a"
          />
          <img v-else src="@/assets/img/mobile_home/Points Store_.png" alt="" class="tab-icon-n" />
        </aside>
        <aside class="nav-item" @click="goTo(3, '/pay')">
          <img
            v-if="routeActive == 3"
            src="@/assets/img/mobile_home/Top-Up-x.png"
            alt=""
            class="tab-icon-a"
          />
          <img v-else src="@/assets/img/mobile_home/Top-Up_.png" alt="" class="tab-icon-n" />
        </aside>
        <aside class="nav-item" @click="goTo(4, '/info')">
          <img
            v-if="routeActive == 4"
            src="@/assets/img/mobile_home/User Centre-x.png"
            alt=""
            class="tab-icon-a"
          />
          <img v-else src="@/assets/img/mobile_home/User Centre_.png" alt="" class="tab-icon-n" />
        </aside>
      </nav>
    </section>
  </header>
</template>

<style scoped>
@media screen and (min-width: 920px) {
  header.mobile-nav-wrapper {
    display: none !important;
  }
}
.mobile-nav-wrapper {
  position: fixed;
  bottom: 0;
  left: 50%;
  width: min(100vw, 430px);
  height: calc(min(13.4667vw, 58px) + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  box-sizing: border-box;
  transform: translateX(-50%);
  z-index: 10000;
  isolation: isolate;
  filter: drop-shadow(0 -1px 2px rgb(0 52 112 / 20%));
}

.mobile-nav-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.header {
  height: 100%;
  width: 100%;
}

.mobile-nav-items {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
}

.mobile-nav-items .nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  height: 100%;
  padding-bottom: max(2%, 2px);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.mobile-nav-items .nav-item img {
  height: 75%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: bottom center;
}
</style>
